import React, { useState } from "react";
import { TRANSACTION_TYPES } from "../utils/constants";
import TransactionDetails from "./TransactionDetails";
import ReportSummary from "./ReportSummary";

const TableHeader = () => (
  <tr>
    <th className="text-white" style={{ backgroundColor: "#83c14a" }}>
      STORE
    </th>
    <th className="text-white" style={{ backgroundColor: "#83c14a" }}>
      Total Amount
    </th>
    <th className="text-white" style={{ backgroundColor: "#83c14a" }}>
      Total Count
    </th>
  </tr>
);

const ReportTable = ({ aggregatedData, totals, voidTotals }) => {
  console.log("aggregatedData", aggregatedData);
  const [selectedStore, setSelectedStore] = useState(null);

  const currencyFormatter = new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const calculateTotals = (storeData) => {
    const totalNet = TRANSACTION_TYPES.reduce(
      (acc, type) => acc + (storeData[type]?.netSale || 0),
      0
    );
    const totalNetSales = TRANSACTION_TYPES.reduce(
      (acc, type) => acc + (storeData[type]?.netSale || 0),
      0
    );
    const totalCount = TRANSACTION_TYPES.reduce(
      (acc, type) => acc + (storeData[type]?.tc || 0),
      0
    );
    return { totalNet, totalCount };
  };

  const handleRowClick = (store) => {
    setSelectedStore((prev) => (prev === store ? null : store));
  };

  // 1) Get entries, 2) sort by store name (the key), 3) map over them
  const sortedEntries = Object.entries(aggregatedData).sort(([a], [b]) =>
    a.localeCompare(b)
  );

  return (
    <table className="table table-hover">
      <thead>
        <TableHeader />
      </thead>

      <tbody>
        {sortedEntries.map(([store, storeData]) => {
          const { totalNet, totalCount } = calculateTotals(storeData);

          return (
            <React.Fragment key={store}>
              <tr
                onClick={() => handleRowClick(store)}
                style={{ cursor: "pointer" }}
              >
                <td>{store}</td>
                <td>{currencyFormatter.format(totalNet)}</td>
                <td>{totalCount}</td>
              </tr>

              {selectedStore === store && (
                <tr>
                  <td colSpan="3">
                    <TransactionDetails
                      storeData={storeData}
                      totalNet={totalNet}
                      totals={totals}
                      voidTotals={voidTotals}
                    />
                    <div className="card mt-2 p-3">
                      <p className="m-0">
                        <span style={{ color: "#83c14a" }}>
                          Total Net Sales:
                        </span>{" "}
                        {currencyFormatter.format(
                          Number(storeData?.totalNetSales || 0)
                        )}
                      </p>
                      <p className="m-0">
                        <span style={{ color: "#83c14a" }}>
                          Total Gross Sales:
                        </span>{" "}
                        {currencyFormatter.format(
                          Number(storeData?.totalGrossSales || 0)
                        )}
                      </p>
                      <p className="m-0">
                        <span style={{ color: "#83c14a" }}>Total Pretax:</span>{" "}
                        {currencyFormatter.format(
                          Number(storeData?.totalPretax || 0)
                        )}
                      </p>
                      <p className="m-0">
                        <span style={{ color: "#83c14a" }}>Total Tax:</span>{" "}
                        {currencyFormatter.format(
                          Number(storeData?.totalTax || 0)
                        )}
                      </p>
                      <p className="m-0">
                        <span style={{ color: "#83c14a" }}>
                          Total Tax Free:
                        </span>{" "}
                        {currencyFormatter.format(
                          Number(storeData?.totalTaxFree || 0)
                        )}
                      </p>
                      <p className="m-0">
                        <span style={{ color: "#83c14a" }}>
                          Total Discount:
                        </span>{" "}
                        {currencyFormatter.format(
                          Number(storeData?.totalDiscount || 0)
                        )}
                      </p>
                      <p className="m-0">
                        <span style={{ color: "#83c14a" }}>
                          Total Void Amount:
                        </span>{" "}
                        {currencyFormatter.format(
                          Number(storeData?.totalVoidAmount || 0)
                        )}
                      </p>
                      <p className="m-0">
                        <span style={{ color: "#83c14a" }}>
                          Total Void Count:
                        </span>{" "}
                        {Number(storeData?.totalVoidCount || 0)}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

export default ReportTable;
